// Razorpay checkout helper — dynamically loads the Razorpay SDK and opens the
// payment modal. Returns a Promise that resolves with the verified payment data
// on success, or rejects on failure/dismissal.

declare global {
  interface Window {
    Razorpay: any;
  }
}

function loadRazorpayScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) { resolve(); return; }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Razorpay SDK'));
    document.head.appendChild(script);
  });
}

export interface RazorpayOrderData {
  order_id: string;
  amount: number;
  currency: string;
  key_id: string;
  plan_name: string;
  prefill?: { name?: string; email?: string };
}

export interface RazorpayPaymentResult {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
}

export async function openRazorpayCheckout(orderData: RazorpayOrderData): Promise<RazorpayPaymentResult> {
  await loadRazorpayScript();

  return new Promise((resolve, reject) => {
    const options = {
      key: orderData.key_id,
      amount: orderData.amount,
      currency: orderData.currency,
      name: 'LocalContact',
      description: orderData.plan_name,
      order_id: orderData.order_id,
      prefill: orderData.prefill ?? {},
      theme: { color: '#f9db47' },
      handler: (response: RazorpayPaymentResult) => resolve(response),
      modal: {
        ondismiss: () => reject(new Error('Payment cancelled')),
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', (response: any) => {
      reject(new Error(response.error?.description ?? 'Payment failed'));
    });
    rzp.open();
  });
}
